import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

const POSSystemContent = () => {
  return (
    <section style={{ padding: '80px 0', backgroundColor: 'var(--white)' }}>
      <Container>
        <Row className="align-items-center">
          <Col lg={6} md={12}>
            <div style={{ marginBottom: '40px' }}>
              <h6
                className="head"
                style={{
                  color: 'var(--primary)',
                  textAlign: 'left',
                  marginBottom: '20px'
                }}
              >
                SMG POS SYSTEM
              </h6>
              <h2
                style={{
                  fontSize: '2.5rem',
                  fontWeight: '700',
                  color: 'var(--darkblue)',
                  marginBottom: '30px',
                  lineHeight: '1.2'
                }}
              >
                Revolutionary Point of Sale Solution
              </h2>
              <p
                className="text"
                style={{
                  fontSize: '16px',
                  lineHeight: '1.8',
                  color: '#666',
                  marginBottom: '25px'
                }}
              >
                Transform your business operations with SMG's advanced Point of
                Sale system. Our comprehensive POS solution is designed to
                streamline your retail, restaurant, or service business with
                cutting-edge technology and user-friendly interfaces.
              </p>
              <p
                className="text"
                style={{
                  fontSize: '16px',
                  lineHeight: '1.8',
                  color: '#666',
                  marginBottom: '30px'
                }}
              >
                Built with modern businesses in mind, our POS system integrates
                seamlessly with your existing operations while providing
                powerful analytics, inventory management, and customer
                relationship tools.
              </p>
              <div
                style={{
                  padding: '20px',
                  backgroundColor: 'var(--primary3)',
                  borderRadius: '10px',
                  borderLeft: '4px solid var(--primary)'
                }}
              >
                <h5 style={{ color: 'var(--primary)', marginBottom: '10px' }}>
                  Why Choose SMG POS?
                </h5>
                <p style={{ color: '#666', margin: 0, fontSize: '15px' }}>
                  Our POS system combines reliability, scalability, and
                  innovation to deliver a solution that grows with your business
                  needs.
                </p>
              </div>
            </div>
          </Col>
          <Col lg={6} md={12}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%'
              }}
            >
              <div
                style={{
                  width: '100%',
                  height: '400px',
                  backgroundColor: 'var(--grey)',
                  borderRadius: '15px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                  overflow: 'hidden',
                  boxShadow: '0 10px 30px rgba(85, 105, 193, 0.1)'
                }}
              >
                {/* Placeholder for POS system image/demo */}
                <div
                  style={{
                    textAlign: 'center',
                    color: 'var(--primary)',
                    padding: '20px'
                  }}
                >
                  <div
                    style={{
                      fontSize: '80px',
                      marginBottom: '20px',
                      opacity: '0.3'
                    }}
                  >
                    💻
                  </div>
                  <h4 style={{ color: 'var(--primary)', fontWeight: '600' }}>
                    SMG POS Interface
                  </h4>
                  <p style={{ color: '#666', fontSize: '14px' }}>
                    Modern, intuitive, and powerful
                  </p>
                </div>

                {/* Decorative elements */}
                <div
                  style={{
                    position: 'absolute',
                    top: '20px',
                    right: '20px',
                    width: '60px',
                    height: '60px',
                    backgroundColor: 'var(--primary)',
                    borderRadius: '50%',
                    opacity: '0.1'
                  }}
                ></div>
                <div
                  style={{
                    position: 'absolute',
                    bottom: '20px',
                    left: '20px',
                    width: '40px',
                    height: '40px',
                    backgroundColor: 'var(--secondary)',
                    borderRadius: '50%',
                    opacity: '0.1'
                  }}
                ></div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default POSSystemContent
